import React, {useContext, useEffect, useRef, useState} from "react";
import {Col, Row, Tab, Tabs} from "react-bootstrap";
import {FormProvider, Resolver, useForm} from "react-hook-form";
import * as XLSX from "xlsx";
import AssemblyDisassemblyOrdersDetailSkeleton from "./AssemblyDisassemblyOrdersDetailSkeleton";
import {
    AssemblyDisassemblyOrdersDto
} from "../../../../../dtos/documents/AssemblyDisassemblyOrders/AssemblyDisassemblyOrdersDto";
import {
    AssemblyDisassemblyOrdersModel
} from "../../../../../models/Documents/AssemblyDIsassemblyOrders/AssemblyDisassemblyOrdersModel";
import {NewDocumentModalViewContext} from "../../../../Shared/NewDocumentModalView";
import handleFormSubmit, {DocumentSaveActionType} from "../../../../../helpers/DocumentHelper";
import {NFTabs} from "../../../../Shared/NewForms/NFTabs";
import {NFTab} from "../../../../Shared/NewForms/NFTab";
import {DocumentModalViewHeader} from "../../../../Shared/DocumentModalViewHeader";
import {NFTabContainer} from "../../../../Shared/NewForms/NFTabContainer";
import {NFTextInput} from "../../../../Shared/NewForms/NFTextInput";
import {NFDateInput} from "../../../../Shared/NewForms/NFDateInput";
import {NFLookupWarehouse} from "../../../../Shared/NewForms/NFLookupWarehouse";
import {NFLookupCompany} from "../../../../Shared/NewForms/NFLookupCompany";
import {NFLookupUnit} from "../../../../Shared/NewForms/NFLookupUnit";
import {NFLookupDivision} from "../../../../Shared/NewForms/NFLookupDivision";
import {NFLookupProduct} from "../../../../Shared/NewForms/NFLookupProduct";
import {NFormTable} from "../../../../Shared/NewForms/NFormTable";
import {NFIntInput} from "../../../../Shared/NewForms/NFIntInput";
import {NFTextAreaInput} from "../../../../Shared/NewForms/NFTextAreaInput";

interface IProps {
    model: AssemblyDisassemblyOrdersDto | null;
    modelUpdatedEvent: (newModel: AssemblyDisassemblyOrdersDto) => void;
}

export const AssemblyDisassemblyOrdersDetail = ({
                                                    model,
                                                    modelUpdatedEvent,
                                                }: IProps) => {
    const [tabIndex, setTabIndex] = useState(0);

    const {
        register,
        handleSubmit,
        setValue,
        formState: {errors},
        reset,
        formState,
        getValues,
        watch,
        control,
        trigger,
        ...methods
    } = useForm<AssemblyDisassemblyOrdersModel>();

    const modalViewContext = useContext(NewDocumentModalViewContext);
    const [fileName, setFileName] = useState("Assembly Disassembly Orders");
    const {postHandler, saveHandler, closeHandler, cancelHandler} =
        modalViewContext;
    const watchProducts = watch("assemblyDisassemblyOrdersGoods");

    useEffect(() => {
        console.log(model);
        register("assemblyDisassemblyOrdersGoods");
        if (model) {
            setValue("id", model.id);
            setValue("documentNumber", model.documentNumber);
            setValue("createdDate", model.createdDate);
            setValue("documentDate", model.documentDate);
            setValue("companyId", model.companyId);
            setValue("divisionId", model.divisionId);
            setValue("unitId", model.unitId);
            setValue("warehouseReceivingId", model.warehouseReceivingId);
            setValue("warehouseExpensingId", model.warehouseExpensingId);
            setValue("productId", model.productId);
            setValue("comment", model.comment);
            setValue("desiredShippingDate", model.desiredShippingDate);
            setValue("createdDate", model.createdDate);
            setValue(
                "assemblyDisassemblyOrdersGoods",
                model.assemblyDisassemblyOrdersGoods
            );
        }
    }, [model]);

    useEffect(() => {
        console.log(watchProducts);
    }, [watchProducts]);

    // const handleFormSubmit = (
    //   action: DocumentSaveActionType,
    //   data: AssemblyDisassemblyOrdersModel
    // ) => {
    //   console.log("form submit");
    //   console.log(data);
    //   console.log(action);
    //   if (action === "save") {
    //     const newModel: AssemblyDisassemblyOrdersDto = { ...model, ...data };
    //     console.log("new model");
    //     console.log(newModel);
    //     // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
    //     saveHandler(newModel);
    //   } else if (action === "post") {
    //     postHandler();
    //   }
    // };

    const handleFormSubmitLocal = async (
        action: DocumentSaveActionType,
        data: AssemblyDisassemblyOrdersModel
    ) => {
        await handleFormSubmit(action, data, model, saveHandler, postHandler);
    };
    if (!model) {
        return (
            <>
                <AssemblyDisassemblyOrdersDetailSkeleton/>
            </>
        );
    }

    const handleTabChange = (index: number) => {
        setTabIndex(index);
    };

    const handlePriceChanged = (newPrice: number, index: number) => {
        const newProducts = [...watchProducts];
        console.log("newProducts", newProducts);
        // @ts-ignore
        const newAmount = newPrice * newProducts[index].quantity;
        setValue(`assemblyDisassemblyOrdersGoods.${index}.amount`, newAmount);
        console.log(newAmount);
    };

    const handleQuantityChanged = (newQuantity: number, index: number) => {
        const newProducts = [...watchProducts];
        console.log("newProducts", newProducts);
        // @ts-ignore
        const newAmount = newQuantity * newProducts[index].price;
        setValue(`assemblyDisassemblyOrdersGoods.${index}.amount`, newAmount);
        console.log(newAmount);
    };
    const handleUploadFile = (file: File) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const binaryString = event.target?.result;
            const workbook = XLSX.read(binaryString, {type: "binary"});
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const worksheetData: any = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
            });
            const documentNumber = worksheetData[1][0];
            const warehouseReceivingId = worksheetData[2][1];
            const companyId = worksheetData[3][2];
            const warehouseExpensingId = worksheetData[4][3];
            const divisionId = worksheetData[5][4];
            const productId = worksheetData[6][5];
            const unitId = worksheetData[7][6];

            let assemblyDisassemblyOrdersGoods = [];
            const productData = {
                productId: worksheetData[6][5],
                unitId: worksheetData[7][6],
            };
            if (worksheetData.length >= 6) {
                assemblyDisassemblyOrdersGoods = worksheetData
                    .slice(8)
                    .map((row: any) => ({
                        productVendorCode: row[7],
                        quantity: row[8],
                        ...productData,
                    }));
            }
            // assemblyDisassemblyOrdersGoods
            setValue("documentNumber", documentNumber);
            setValue("divisionId", divisionId);
            setValue("warehouseReceivingId", warehouseReceivingId);
            setValue("companyId", companyId);
            setValue("warehouseExpensingId", warehouseExpensingId);
            setValue("productId", productId);
            setValue("unitId", unitId);
            setValue(
                "assemblyDisassemblyOrdersGoods",
                assemblyDisassemblyOrdersGoods
            );
        };
        reader.readAsBinaryString(file);
    };

    const exportToExcel = () => {
        try {
            const data = {
                documentNumber: model.documentNumber,
                companyId: model.companyId,
                warehouseReceivingId: model.warehouseReceivingId,
                warehouseExpensingId: model.warehouseExpensingId,
                divisionId: model.divisionId,
                productId: model.productId,
                unitId: model.unitId,
                assemblyDisassemblyOrdersGoods: model.assemblyDisassemblyOrdersGoods,
            };
            const ws = XLSX.utils.json_to_sheet([
                {documentNumber: data.documentNumber},
                {warehouseReceivingId: data.warehouseReceivingId},
                {companyId: data.companyId},
                {warehouseExpensingId: data.warehouseExpensingId},
                {divisionId: data.divisionId},
                {productId: data.productId},
                {unitId: data.unitId},
                ...(data.assemblyDisassemblyOrdersGoods
                    ? data.assemblyDisassemblyOrdersGoods.map((item) => ({
                        productId: item.productId,
                        productVendorCode: item.productVendorCode,
                        quantity: item.quantity,
                        unitId: item.unitId,
                    }))
                    : []),
            ]);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            const exportFileName = `${fileName}.xls`;
            XLSX.writeFile(wb, exportFileName);
            setFileName(exportFileName);
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <FormProvider
            getValues={getValues}
            setValue={setValue}
            register={register}
            control={control}
            trigger={trigger}
            reset={reset}
            watch={watch}
            handleSubmit={handleSubmit}
            formState={formState}
            {...methods}
        >
            <NFTabs
                onTabChange={(newIndex) => {
                    setTabIndex(newIndex);
                }}
            >
                <NFTab title={"Main"}/>
                <NFTab title={"Products"}/>
                <NFTab title={"Additional"}/>
            </NFTabs>

            <div className={"modal-container-height"}>
                <DocumentModalViewHeader
                    onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
                    onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
                    onClose={closeHandler}
                    onCancel={cancelHandler}
                    handleUploadFile={handleUploadFile}
                    exportToExcel={exportToExcel}
                    fileName={fileName}
                    setFileName={setFileName}
                />

                <NFTabContainer index={0} currentIndex={tabIndex}>
                    <Row>
                        <Col sm={6}>
                            <NFTextInput
                                title={"Document #"}
                                fieldName={"documentNumber"}
                                disabled
                            />
                        </Col>
                        <Col sm={6}>
                            <NFDateInput
                                title={"Document Date"}
                                fieldName={"documentDate"}
                                required={true}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <NFDateInput
                                title={"Created Date"}
                                fieldName={"createdDate"}
                                required={true}
                            />
                        </Col>
                        <Col sm={6}>
                            <NFDateInput
                                title={"Desired Shipping Date"}
                                fieldName={"desiredShippingDate"}
                                required={true}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <NFLookupWarehouse
                                fieldName={"warehouseReceivingId"}
                                title={"warehouseReceivingId"}
                                companyId={watch("companyId")}
                            />
                        </Col>
                        <Col sm={6}>
                            <NFLookupCompany fieldName={"companyId"} title={"Company"}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <NFLookupWarehouse
                                fieldName={"warehouseExpensingId"}
                                title={"warehouseExpensingId"}
                                companyId={watch("companyId")}
                            />
                        </Col>
                        <Col sm={6}>
                            <NFLookupUnit fieldName={"unitId"} title={"Unit"}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <NFLookupDivision fieldName={"divisionId"} title={"Division"} companyId={watch('companyId')}/>
                        </Col>
                        <Col sm={6}>
                            <NFLookupProduct
                                fieldName={"productId"}
                                title={"Product"}
                                required={true}
                            />
                        </Col>
                    </Row>
                </NFTabContainer>

                <NFTabContainer index={1} currentIndex={tabIndex}>
                    <div className={"panel-body tabs-menu-body main-content-body-right"}>
                        <NFormTable fieldArray={"assemblyDisassemblyOrdersGoods"}>
                            <NFLookupProduct
                                fieldName={"productId"}
                                title={"Product"}
                                required={true}
                                width={300}
                            />
                            <NFTextInput
                                fieldName={"productVendorCode"}
                                title={"Product Vendor Code"}
                            />
                            <NFLookupUnit title="Unit" fieldName="unitId"/>
                            <NFIntInput
                                fieldName={"quantity"}
                                title={"Quantity"}
                                width={100}
                                onValueChanged={handleQuantityChanged}
                            />
                            <NFIntInput
                                fieldName={"price"}
                                title={"Price"}
                                width={100}
                                onValueChanged={handlePriceChanged}
                            />
                            <NFIntInput fieldName={"amount"} title={"Amount"} width={100}/>
                        </NFormTable>
                    </div>
                </NFTabContainer>

                <NFTabContainer index={2} currentIndex={tabIndex}>
                    <div className={"panel-body tabs-menu-body main-content-body-right"}>
                        <Row>
                            <Col sm={12}>
                                <NFTextAreaInput
                                    fieldName={"comment"}
                                    title={"Comment"}
                                    required={false}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <NFTextInput
                                    title={"Created User"}
                                    fieldName={"createdUser"}
                                    disabled={true}
                                />
                            </Col>
                            <Col sm={6}>
                                <NFDateInput
                                    title={"Created Date"}
                                    fieldName={"createdDate"}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                    </div>
                </NFTabContainer>
            </div>
        </FormProvider>
    );
};
